import { ServiceOption } from "@/@types/Rating/AvailableRate";
import useAlertBar from "@/hooks/useAlertBar";
import { getLTLServiceOptionsMapper } from "@/mappers/rating/getServiceOptionsMapper";
import { getLTLServiceOptionsService } from "@/services/rateService";
import { numberStringMaskInput } from "@/utils/common-functions";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Accordion,
  Row,
  Col,
  Input,
} from "reactstrap";

type Props = {
  setSelectedOptions: Dispatch<SetStateAction<ServiceOption[]>>;
  selectedOptions: ServiceOption[];
};

const getQualifierLabel = (serviceType: string) => {
  switch (serviceType) {
    case "EXCESS_VALUE":
      return "Value Amount";
    case "EXT_LENGTH":
      return "Longest Side";
    case "SORT_SEGREGATE":
      return "Pieces to Sort";
  }
};

const FreightServiceOptions = ({
  setSelectedOptions,
  selectedOptions,
}: Props) => {
  const [open, setOpen] = useState("1");
  const [LTLServiceOptionsList, setLTLServiceOptionsList] =
    useState<ServiceOption[]>();
  const { openAlertBar } = useAlertBar();

  const fetchLTLServiceOptions = async () => {
    try {
      const { data } = await getLTLServiceOptionsService(["TFORCE"]);

      if (data.status) {
        const mappingData = getLTLServiceOptionsMapper(data.data);
        setLTLServiceOptionsList(mappingData);
        setSelectedOptions([]);
      } else {
        openAlertBar(data.message, false);
      }
    } catch (error) {
      openAlertBar("getServiceOptions API Error", false);
    }
  };

  // discover the service options
  useEffect(() => {
    // LTL Services
    fetchLTLServiceOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <div className="mt-5">
      {/*@ts-ignore*/}
      <Accordion open={open} toggle={toggle}>
        <AccordionItem>
          <AccordionHeader targetId={"1"}>
            <h6>Choose Freight Service Add Ons</h6>
          </AccordionHeader>
          <AccordionBody accordionId={"1"}>
            <Row>
              {LTLServiceOptionsList?.map((l) => (
                <Col sm={4} key={l.optionCode} className="mb-3">
                  <label htmlFor={l.optionCode}>
                    <Input
                      id={l.optionCode}
                      type="checkbox"
                      onChange={(e) => {
                        let LTLOptionsPre = [...selectedOptions];

                        if (e.target.checked) {
                          if (
                            l.optionCode === "EXT_LENGTH" ||
                            l.optionCode === "EXCESS_VALUE" ||
                            l.optionCode === "SORT_SEGREGATE"
                          ) {
                            LTLOptionsPre.push({
                              ...l,
                              qualifier: "",
                            });
                          } else {
                            LTLOptionsPre.push(l);
                          }
                        } else {
                          LTLOptionsPre = LTLOptionsPre.filter(
                            (opt) => opt.optionCode !== l.optionCode
                          );
                        }
                        setSelectedOptions(LTLOptionsPre);
                      }}
                    />{" "}
                    {l.optionName}
                  </label>
                  {(l.optionCode === "EXT_LENGTH" ||
                    l.optionCode === "EXCESS_VALUE" ||
                    l.optionCode === "SORT_SEGREGATE") &&
                    selectedOptions?.find(
                      (opt) => opt.optionCode === l.optionCode
                    ) && (
                      <Input
                        required
                        className="mt-2"
                        placeholder={getQualifierLabel(l.optionCode)}
                        value={
                          selectedOptions?.find(
                            (opt) => opt.optionCode === l.optionCode
                          )?.qualifier
                        }
                        onChange={(e) => {
                          setSelectedOptions((opt) => {
                            let updated = [...opt];
                            let index = opt.findIndex(
                              (s) => s.optionCode === l.optionCode
                            );

                            updated[index] = {
                              ...updated[index],
                              qualifier: numberStringMaskInput(e.target.value),
                            };
                            console.log(updated);
                            return updated;
                          });
                        }}
                      />
                    )}
                </Col>
              ))}
            </Row>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default FreightServiceOptions;
